import { render, staticRenderFns } from "./QuoteBoard.vue?vue&type=template&id=7ef020b0&scoped=true"
import script from "./QuoteBoard.vue?vue&type=script&lang=js"
export * from "./QuoteBoard.vue?vue&type=script&lang=js"
import style0 from "./QuoteBoard.vue?vue&type=style&index=0&id=7ef020b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef020b0",
  null
  
)

export default component.exports